module.exports = require("@ember/version");